import {
  dateTimeToHour,
  isOneWeekOrLess,
  isMoreThanOneWeek,
  isMoreThanThreeMonth,
} from 'utils';

/**
 * Charts whose granularity follows the range of the current date filter, so the
 * selected gap is re-clamped to `getAvailableTimeGaps` whenever the range moves.
 */
const RANGE_BASED_TIME_GAP_KEYS = [
  'postsPublishProcess',
  'batchPublishProcess',
  'storyPublicationComparison',
  'voiceTrendTimeGap',
  'nssTrend',
  'nssTrendTimeGap',
];

/** Of those, the ones that have hourly data to fall back on under 24 hours. */
const HOURLY_TIME_GAP_KEYS = [
  'postsPublishProcess',
  'postsPublishSpeed',
  'batchPublishProcess',
];

/** Charts with no hourly view, which show a single daily bucket for a sub-24h range. */
const DAILY_ONLY_TIME_GAP_KEYS = ['nssTrend'];

export const isValidTimeGap = (timeGap, type = 'daily') => {
  if (type === 'daily') return ['day', 'hour'].includes(timeGap);
  if (type === 'weekly') return ['day', 'week'].includes(timeGap);
  if (type === 'monthly') return ['week', 'month'].includes(timeGap);
};

export const getAvailableTimeGaps = (currentDate) => {
  let timeGaps = [];

  if (isMoreThanThreeMonth(currentDate)) {
    timeGaps = ['week', 'month'];
  } else if (isMoreThanOneWeek(currentDate)) {
    timeGaps = ['day', 'week'];
  } else if (isOneWeekOrLess(currentDate)) {
    timeGaps = ['day', 'hour'];
  }

  return timeGaps;
};

export const getTimeGap = (timeGap = '', currentDate) => {
  let selectedTimeGap = timeGap;
  if (
    isMoreThanThreeMonth(currentDate) &&
    !isValidTimeGap(timeGap, 'monthly')
  ) {
    selectedTimeGap = 'week';
  } else if (
    isMoreThanOneWeek(currentDate) &&
    !isValidTimeGap(timeGap, 'weekly')
  ) {
    selectedTimeGap = 'day';
  } else if (
    isOneWeekOrLess(currentDate) &&
    !isValidTimeGap(timeGap, 'daily')
  ) {
    selectedTimeGap = 'hour';
  }
  return selectedTimeGap;
};

export const applyTimeGapsOfCurrentPage = ({
  pageName,
  currentDate,
  state,
}) => {
  const isOneDayOrLess =
    dateTimeToHour(
      currentDate.timeDuration,
      currentDate.fromDate,
      currentDate.toDate
    ) <= 24;
  const currentPage = state[pageName];
  Object.keys(currentPage).forEach((platform) => {
    const charts = currentPage[platform];
    const applyToCharts = (keys, resolveTimeGap) => {
      keys.forEach((key) => {
        if (charts[key]) charts[key] = resolveTimeGap(charts[key]);
      });
    };

    // in brandBaan page, if the current date is one week or less, set the time gap to daily it doesn't have hourly data
    if (pageName === 'brandBaan' && isOneWeekOrLess(currentDate)) {
      applyToCharts(RANGE_BASED_TIME_GAP_KEYS, () => 'day');
    } else if (isOneDayOrLess) {
      applyToCharts(HOURLY_TIME_GAP_KEYS, () => 'hour');
      applyToCharts(DAILY_ONLY_TIME_GAP_KEYS, () => 'day');
    } else {
      applyToCharts(RANGE_BASED_TIME_GAP_KEYS, (timeGap) =>
        getTimeGap(timeGap, currentDate)
      );
    }

    // the NSS trend has no hourly view, so a range-based fallback to hour lands on day
    if (charts.nssTrend === 'hour') charts.nssTrend = 'day';
  });
};
